export const SET_GROUP_LIST = 'SET_GROUP_LIST';
export const SET_GROUP_FOCUS = 'SET_GROUP_FOCUS';
export const SET_GROUP_COMPONENT_TYPE = 'SET_GROUP_COMPONENT_TYPE';
export const DELETE_GROUP_LIST = 'DELETE_GROUP_LIST';
export const SET_GROUP_STATUS = 'SET_GROUP_STATUS';
export const SET_GROUP_PANEL = 'SET_GROUP_PANEL';
export const INIT_GROUP_LIST = 'INIT_GROUP_LIST';
export const SET_ASSIGN_GROUP_ID = 'SET_ASSIGN_GROUP_ID';
export const SET_LAST_GROUP_UPDATE_TIME = 'SET_LAST_GROUP_UPDATE_TIME';
export const CLEAR_GROUP_LIST = "CLEAR_GROUP_LIST";
